<template lang="">
    <div id="labEdit" ref="labEdit">
        <b-form-group
            class="source"
            :label-for="`source`"
            :label-cols="4"
            label="Source:"
        >
            <b-input :value="getLabSource()" plaintext />
        </b-form-group>
        <b-form-group :label-for="`item`" :label-cols="4" label="Item(s):">
            <div v-for="item in lab.data.lab_items" :key="item.id">
                <b-input :value="item.name" plaintext />
            </div>
        </b-form-group>
        <b-form-group
            :label-for="`order_date`"
            :label-cols="4"
            label="Ordered:"
        >
            <vet-datetime
                v-if="isEditable()"
                v-model="orderDate"
                v-validate="'required'"
                :placeholder="{
                    date: whichPlaceholder.orderedDate.placeholder,
                    time: 'Time (required)'
                }"
                :inner-class="{
                    'border-danger': errors.has('orderDate')
                }"
                rules="required"
                container=""
                name="orderDate"
                :isUpdatePosition="false"
                @mouseover.native="
                    showDateFormatPlaceholder('orderedDate', true)
                "
                @mouseout.native="
                    showDateFormatPlaceholder('orderedDate', false)
                "
                :disabled="isSaving"
                autocomplete="off"
            ></vet-datetime>
            <b-input
                v-else
                :value="showDate(lab.data.record_resource.ordered_date)"
                plaintext
            />
        </b-form-group>
        <b-form-group
            v-if="lab.data.record_resource.summary.status"
            label-cols="4"
            label="Status:"
            label-for="status"
        >
            <b-input
                :value="showStatusLabel(lab.data.record_resource)"
                plaintext
            />
        </b-form-group>
        <b-form-group
            v-else
            label-for="received"
            label="Received:"
            label-cols="4"
        >
            <date-picker
                v-if="isEditable()"
                :config="datePickerOptions"
                v-model="received"
                :placeholder="whichPlaceholder.receivedDate.placeholder"
                class="form-control"
                name="received"
                @mouseover.native="
                    showDateFormatPlaceholder('receivedDate', true)
                "
                @mouseout.native="
                    showDateFormatPlaceholder('receivedDate', false)
                "
                :disabled="isSaving"
                autocomplete="off"
            ></date-picker>
            <b-input
                v-else
                :value="showDate(lab.data.record_resource.received_date)"
                plaintext
            />
        </b-form-group>
        <b-form-group label-for="next_due" label="Next Due:" label-cols="4">
            <date-picker
                v-if="isEditable()"
                :config="datePickerOptions"
                v-model="nextDue"
                :placeholder="whichPlaceholder.reminderDate.placeholder"
                class="form-control"
                name="next_due"
                @mouseover.native="
                    showDateFormatPlaceholder('reminderDate', true)
                "
                @mouseout.native="
                    showDateFormatPlaceholder('reminderDate', false)
                "
                :disabled="isSaving"
                autocomplete="off"
            ></date-picker>
            <b-input
                v-else
                :value="getNextDue(lab.data.record_resource)"
                plaintext
            />
        </b-form-group>
        <b-form-group
            v-if="isShowSendToLab(record)"
            label-cols="4"
            :label="sendToLabLabel(record)"
            label-for="sendTo"
        >
            <b-select
                v-if="isEditable()"
                v-model="sendTo"
                class="form-control"
                name="sendTo"
                :disabled="isSaving"
            >
                <option value="1">Yes</option>
                <option value="0">No</option>
            </b-select>
            <div v-else>
                <b-input
                    v-if="Number(lab.data.record_resource.send_to) === 1"
                    value="Yes"
                    plaintext
                />
                <b-input
                    v-else-if="Number(lab.data.record_resource.send_to) === 0"
                    value="No"
                    plaintext
                />
            </div>
        </b-form-group>
        <b-form-group
            v-if="requisitionId"
            label="Requisition Id:"
            label-cols="4"
            label-for="requisition-id"
        >
            <div
                id="requisition-id"
                class="col-form-label"
                v-html="requisitionId"
            ></div>
        </b-form-group>
        <b-form-group
            label="Provider:"
            class
            label-cols="4"
            label-for="staff_id"
        >
            <v-select
                id="staffs"
                ref="vselect"
                v-validate="'required'"
                :class="{ 'border-danger': errors.has('staffs') }"
                :options="providers"
                v-model="provider"
                :label="'name'"
                name="staffs"
                aria-placeholder="true"
                placeholder="Provider (required)"
                :disabled="isSaving"
            ></v-select>
        </b-form-group>
        <b-form-group label-cols="4" label="Invoice:" label-for="invoice">
            <b-form-select
                v-if="isEditable('invoice')"
                id="invoice"
                v-model="invoice"
                :options="invoiceFilter"
                name="invoice"
                :disabled="isSaving"
            ></b-form-select>
            <invoice-link
                v-else
                :invoice="record.selected_invoice"
                :newTab="false"
            />
        </b-form-group>
        <b-form-group
            v-if="_.isArray(item) && item.length == 1"
            label-cols="4"
            label="Print on Invoice:"
            label-for="printOnInvoice"
        >
            <b-select
                v-if="isEditable('invoice')"
                v-model="printOnInvoice"
                class="form-control"
                name="printOnInvoice"
                :disabled="isSaving"
            >
                <option value="1">Yes</option>
                <option value="0">No</option>
            </b-select>
            <div v-else>
                <b-input v-if="printOnInvoice === 1" value="Yes" plaintext />
                <b-input
                    v-else-if="printOnInvoice === 0"
                    value="No"
                    plaintext
                />
            </div>
        </b-form-group>
        <b-form-group
            class="medical-note"
            :label-for="`soap`"
            :label-cols="4"
            label="Medical Note:"
        >
            <b-form-select
                id="soap"
                v-model="soap"
                :options="soapFilter"
                name="soap"
                :disabled="isSaving"
            ></b-form-select>
        </b-form-group>
        <b-form-group
            label="Open Diagnoses:"
            label-cols="4"
            label-for="diagnoses"
        >
            <v-select
                ref="vselect"
                v-model="diagnosis"
                :options="diagnosisFilter"
                :label="'text'"
                name="diagnoses"
                multiple
                aria-placeholder="true"
                placeholder="Open Diagnoses (optional)"
                :disabled="isSaving"
            ></v-select>
        </b-form-group>
        <b-form-group
            :label-for="`instruction`"
            :label-cols="4"
            label="Instructions:"
        >
            <editable-textarea
                id="instruction"
                divId="instruction"
                ref="editableInstruction"
                v-model="data.instruction"
                placeholder="Instructions for lab technician (optional)"
                :disabled="isSaving"
            ></editable-textarea>

            <span
                class="pt-1 text-right d-block"
                :style="{ color: instructionCount >= 0 ? 'grey' : 'red' }"
                style="font-size: 10px;"
            >{{ instructionCount }} character(s) remaining</span>
        </b-form-group>
        <b-form-group
            label-for="record_note"
            label="Notes/Results:"
            label-cols="4"
        >
            <editable
                id="record_note"
                ref="editable"
                :value.sync="notes"
                placeholder="Notes (optional)"
                :preventPreTag="true"
                :disabled="isSaving"
            ></editable>
        </b-form-group>
    </div>
</template>
<script>
import {
    difference,
    sortBy,
    forEach,
    orderBy,
    defaultTo,
    find,
    map,
    filter
} from "lodash";
import vSelect from "vue-select";
import vetDatetime from "@/module/commons/date-time-picker.vue";
import PatientLabService from "@/services/patient/patient-lab";
import EXTENSIONS from "@/constants/extensions";
import RecordHelper from "@/mixins/record.js";
import LabHelper from "@/mixins/lab.js";
import ScheduleHelper from "@/module/schedule/helper";
import { DateTime } from "luxon";
import CBILLINGS from "@/constants/billings";
import INVOICEITEM from "@/constants/invoice-item";
import joinPaymentInvoiceSocket from "@/mixins/join-payment-invoice-socket.js";

export default {
    name: "labEdit",
    components: {
        vSelect,
        vetDatetime,
        editable: () => import("@/components/elements/editable"),
        editableTextarea: () => import("@/components/elements/editable-textarea"),
        InvoiceLink: () => import("@/components/commons/invoice-link")
    },
    mixins: [ScheduleHelper, RecordHelper, LabHelper, joinPaymentInvoiceSocket],
    props: {
        lab: {
            type: Object,
            required: true
        },
        mode: {
            type: String,
            required: true
        },
        isSaving: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            data: {
                instruction: ""
            },
            source: "",
            item: "",
            vetItemProps: {
                id: "",
                item_type: "",
                module: "patient",
                status: "",
                start: "",
                source: ""
            },
            datePickerOptions: {
                format: "DD/MM/YYYY",
                useCurrent: false
            },
            orderDate: this._now(),
            status: "",
            received: "",
            nextDue: "",
            send_to_analyzer: "",
            provider: "",
            invoice: "",
            printOnInvoice: true,
            soap: "",
            diagnosis: [],
            instructions: "",
            notes: "",
            instructionCount: 200,
            providers: [],
            sendTo: 0,
            diagnosisOption: [],
            whichPlaceholder: {
                orderedDate: {
                    placeholder: "Ordered Date (required)"
                },
                receivedDate: {
                    placeholder: "Received Date (optional)"
                },
                reminderDate: {
                    placeholder: "Reminder Date (optional)"
                }
            },
            INVOICEITEM,
            disabledOnInvoiceStatus: [
                INVOICEITEM.INVOICE_LIST_STATUS.WRITE_OFF,
                INVOICEITEM.INVOICE_LIST_STATUS.PAID,
                INVOICEITEM.INVOICE_LIST_STATUS.LOCKED
            ]
        };
    },
    watch: {
        // instructions(value) {
        //     let self = this;
        //     if (value && value.length > -1) {
        //         self.instructionCount = 200 - value.length;
        //     }
        //     if (self.instructionCount < 0) {
        //         self.continues = false;
        //     } else {
        //         self.continues = true;
        //     }
        // }
        source(newValue, oldValue) {
            if (oldValue && newValue != oldValue) {
                this.item = null;
                this.vetItemProps.source = newValue;
                this.$refs["select-item"].clear();
            }
        },
        item(newValue, oldValue) {
            if (newValue.length == 0) {
                this.nextDue = "";
            }
            if (
                newValue.length == 1 &&
                oldValue.length == 0 &&
                newValue[0].due
            ) {
                this.nextDue = newValue[0].due;
            }
        },
        invoice(val) {
            this.$store.commit("billing/setInvoiceIdLabProfileEdit", val);
            if (val) {
                this.joinPaymentInvoice(val);
            }
        }
    },
    computed: {
        invoiceStatus() {
            return this.lab.data.record_resource?.selected_invoice?.status;
        },
        labData() {
            return this.lab.data;
        },
        record() {
            return this.lab.data.record_resource;
        },
        diagnosisFilter() {
            return difference(this.diagnosisOption, this.diagnosis);
        },
        soapFilter() {
            let self = this;
            let soapOptions = {};
            soapOptions[-1] = "No Medical Note";
            Object.assign(soapOptions, self.lab.data.soap_resources);
            return soapOptions;
        },
        sourceFilter() {
            let self = this;
            let source = [];

            let enabledHeska = self.getEnabledHeska();
            forEach(self.lab.data.source_resources, function (data, key) {
                // replace heska related value based on which Heska is enabled
                if (
                    [
                        EXTENSIONS.CODE.CODE_HESKA_CLOUD,
                        EXTENSIONS.CODE.CODE_ONPREM_HESKA_UPPERCASE
                    ].includes(key.toUpperCase())
                ) {
                    // only use key with uppercase old heska
                    if (
                        key.toUpperCase() ==
                        EXTENSIONS.CODE.CODE_ONPREM_HESKA_UPPERCASE
                    ) {
                        key = EXTENSIONS.CODE.CODE_ONPREM_HESKA_UPPERCASE;
                        data = EXTENSIONS.CODE.CODE_ONPREM_HESKA + "*";
                    }

                    // if user enabled old Heska, and the source is Heska Cloud, the value would be Heska Cloud
                    // vice versa if user enabled heska cloud
                    if (
                        enabledHeska ==
                            EXTENSIONS.CODE.CODE_ONPREM_HESKA_UPPERCASE &&
                        self.record.source == EXTENSIONS.CODE.CODE_HESKA_CLOUD
                    ) {
                        key = EXTENSIONS.CODE.CODE_HESKA_CLOUD;
                        data = EXTENSIONS.CODE.CODE_ONPREM_HESKA;
                    } else if (
                        enabledHeska == EXTENSIONS.CODE.CODE_HESKA_CLOUD &&
                        self.record.source ==
                            EXTENSIONS.CODE.CODE_ONPREM_HESKA_UPPERCASE
                    ) {
                        key = EXTENSIONS.CODE.CODE_ONPREM_HESKA_UPPERCASE;
                        data = EXTENSIONS.CODE.CODE_ONPREM_HESKA + "*";
                    }
                }
                source.push({
                    value: key ? key : null,
                    text:
                        data == EXTENSIONS.CODE.CODE_HESKA_CLOUD
                            ? EXTENSIONS.CODE.CODE_ONPREM_HESKA
                            : data
                });
            });
            return orderBy(source, "value", "desc");
        },
        invoiceFilter() {
            let self = this;
            let invoices = [];
            forEach(self.lab.data.invoice_resources, function (data) {
                invoices.push({
                    value: data.id,
                    text:
                        data.name +
                        " (" +
                        self._carbonDateDisplay(data.start) +
                        ")"
                });
            });

            invoices.push({
                value: CBILLINGS.INVOICE_LIST.TYPE_NEW_INVOICE,
                text: "New Invoice"
            });

            if (!self.record.selected_invoice?.isactive) {
                // VET-1430, -4 indicate ID for "Do not invoice" option. This also remove option if lab is initially created with invoice.
                invoices.push({
                    value: CBILLINGS.INVOICE_LIST.TYPE_DO_NOT_INVOICE,
                    text: "Do not invoice"
                });
            } else if (
                self.record.selected_invoice.status ==
                CBILLINGS.INVOICE.TYPE_LOCKED
            ) {
                // --- include current invoice in list if current invoice is locked
                invoices.push({
                    value: self.record.selected_invoice.id,
                    text:
                        self.record.selected_invoice.name +
                        " (" +
                        self._carbonDateDisplay(
                            self.record.selected_invoice.start
                        ) +
                        ")"
                });
            }

            return orderBy(invoices, "value", "desc");
        },
        requisitionId() {
            let recordResource = this.lab.data.record_resource;
            let labSource = recordResource.source;
            if (!labSource) return false;
            if (labSource.includes("IDEXX_DEVICE")) labSource = "IDEXX_DEVICE";

            let requisitionId = null;

            switch (labSource) {
                case EXTENSIONS.CODE.CODE_ANTECH_EAST:
                case EXTENSIONS.CODE.CODE_ANTECH_WEST:
                case EXTENSIONS.CODE.CODE_IDEXX:
                case EXTENSIONS.CODE.CODE_IDEXX_DEVICE:
                case EXTENSIONS.CODE.CODE_MIDWEST:
                case EXTENSIONS.CODE.CODE_NBIOVET:
                case EXTENSIONS.CODE.CODE_ZNLABS:
                case EXTENSIONS.CODE.CODE_VETEK:
                case EXTENSIONS.CODE.CODE_MICROVET:
                case EXTENSIONS.CODE.CODE_BIONOTE:
                case EXTENSIONS.CODE.CODE_HESKA_CLOUD:
                    if (
                        recordResource.antechOrder &&
                        recordResource.antechOrder.requisition_id
                    ) {
                        requisitionId =
                            recordResource.antechOrder.requisition_id;

                        if (
                            (labSource === EXTENSIONS.CODE.CODE_IDEXX ||
                                labSource.includes("IDEXX_DEVICE")) &&
                            recordResource.antechOrder.result_received
                        ) {
                            requisitionId =
                                '<a href="' +
                                recordResource.antechOrder.result_url +
                                '" target="_blank">' +
                                recordResource.antechOrder.requisition_id +
                                "</a>";
                        }
                    }
                    break;
            }

            return requisitionId;
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        showDateFormatPlaceholder(type, show) {
            if (show) {
                this.whichPlaceholder[
                    type
                ].placeholder = this.datePickerOptions.format;
            } else {
                switch (type) {
                    case "orderedDate":
                        this.whichPlaceholder[type].placeholder =
                            "Ordered Date (required)";
                        break;
                    case "receivedDate":
                        this.whichPlaceholder[type].placeholder =
                            "Received Date (optional)";
                        break;
                    case "reminderDate":
                        this.whichPlaceholder[type].placeholder =
                            "Reminder Date (optional)";
                        break;
                }
            }
        },
        init() {
            let self = this;
            self.$nextTick(async () => {
                self.datePickerOptions.format = this.getDateFormat();
                await self.getStaffList(self.lab.data.record_resource.source);
                if (self.record.source == EXTENSIONS.CODE.CODE_ONPREM_ABAXIS) {
                    self.source =
                        self.sourceFilter && self.sourceFilter.length > 1
                            ? self.sourceFilter[1].value
                            : "";
                } else {
                    self.source = self.record.source
                        ? self.record.source.toUpperCase()
                        : EXTENSIONS.CODE.CODE_OTHER;
                }
                self.soap = self.record.soap_id ? self.record.soap_id : "-1";
                self.invoice = self.record.selected_invoice?.isactive
                    ? this.preSelectInvoice(self)
                    : CBILLINGS.INVOICE_LIST.TYPE_DO_NOT_INVOICE;
                self.vetItemProps.source = self.source;
                self.vetItemProps.start = DateTime.local()
                    .setZone(self._timeZone)
                    .toFormat(self._dateFormat);
                self.orderDate = self.record.ordered_date
                    ? self._fromDateCarbon(self.record.ordered_date)
                    : null;
                self.notes = self.lab.data.record_resource.note;
                self.item = self.labData.lab_items.map(item => ({
                    id: item.id,
                    label: item.display_name_details
                }));
                self.printOnInvoice = self.record.invoice_item
                    ? self.record.invoice_item.print_on_invoice
                    : 1;
                self.sendTo =
                    self.record.send_to != "" ? self.record.send_to : 0;
                self.data.instruction = self.record.instruction;
                self.diagnosisOption = this.lab.data.diagnosis_resources.map(
                    value => ({
                        value: value.id,
                        text: value.description
                    })
                );
                self.diagnosis = self.labData.diagnoses_ids
                    ? filter(self.diagnosisOption, option => {
                          return self.labData.diagnoses_ids.includes(
                              option.value
                          );
                      })
                    : [];

                self.received = this._carbonDateTimeDisplay(
                    self.record.received_date
                );
                self.nextDue = self.record.reminder_date;
            });
        },
        preSelectInvoice(self) {
            // find if selected invoice in list
            let selInvoice = find(self.lab.data.invoice_resources, invoice => {
                return invoice.id == self.record.selected_invoice.id;
            });

            // if no selected invoice in list, auto populate first from the list, followed CI.
            // add check is_locked to prevent return if invoice is_paid
            if (!selInvoice) {
                if (
                    self.record.selected_invoice &&
                    self.disabledOnInvoiceStatus.includes(
                        self.record.selected_invoice.status
                    )
                ) {
                    return self.record.selected_invoice.id;
                } else {
                    let oriInvoices = self.lab.data.invoice_resources;
                    return oriInvoices.length > 0
                        ? self.lab.data.invoice_resources[
                              oriInvoices.length - 1
                          ].id
                        : -1;
                }
            }

            return self.lab.data.record_resource.invoice_id;
        },
        getLabSource() {
            let self = this;
            let displayDevice = "";
            if (self.labData) {
                let source = self.labData.record_resource.source;
                let resourceOption = self.labData.source_resources;
                displayDevice = resourceOption[source];
                // show * for old heska source
                if (
                    source == EXTENSIONS.CODE.CODE_ONPREM_HESKA ||
                    source == EXTENSIONS.CODE.CODE_ONPREM_HESKA_UPPERCASE
                ) {
                    displayDevice = EXTENSIONS.CODE.CODE_ONPREM_HESKA + "*";
                } else if (source == EXTENSIONS.CODE.CODE_HESKA_CLOUD) {
                    displayDevice = EXTENSIONS.CODE.CODE_ONPREM_HESKA;
                }
            }
            return displayDevice;
        },
        isEditable(params) {
            let isEdit = this.mode == "EDIT";
            let labRecord = this.lab.data.record_resource;
            let isOnPrem =
                labRecord.source == EXTENSIONS.CODE.CODE_ONPREM_ABAXIS ||
                labRecord.source == EXTENSIONS.CODE.CODE_ONPREM_HESKA;

            if (labRecord.send_to == "1" && params != "invoice") {
                isEdit = false;
            }

            switch (params) {
                case "source":
                    if (labRecord.send_to == 1) {
                        isEdit = false;
                    }

                    if (
                        (!labRecord.is_new &&
                            labRecord.is_locked &&
                            isOnPrem &&
                            isEdit) ||
                        (labRecord.is_abaxis_api && labRecord.send_to == 1)
                    ) {
                        isEdit = false;
                    }
                    break;
                case "item":
                    // VET-5528 - Disable change item medical record
                    isEdit = false;
                    break;
                case "invoice":
                    if (
                        !labRecord.is_new &&
                        (labRecord.selected_invoice?.status ==
                            INVOICEITEM.INVOICE_LIST_STATUS.PAID ||
                            labRecord.selected_invoice?.status ==
                                INVOICEITEM.INVOICE_LIST_STATUS.WRITE_OFF)
                    ) {
                        isEdit = false;
                    }
                    break;

                default:
                    break;
            }

            return isEdit;
        },
        async getStaffList(source) {
            let self = this;
            let labSource = "";
            if (
                source === "ZNLABS" ||
                source === "VETEK" ||
                source === "MICROVET" ||
                source === "BIONOTE"
            ) {
                self.labData.staff_id = "";
                labSource = "&source=" + source;
            }
            return await this.$http
                .get(
                    process.env.APPS +
                        "index.php/ajax/staff/filter_administrator_veterinarian_sql?search_key=" +
                        labSource
                )
                .then(function (response) {
                    if (response.data) {
                        self.providers = response.data;
                        self.providers = sortBy(self.providers, ["name"]);
                        self.provider = self.record.prescribed_by
                            ? defaultTo(
                                  find(self.providers, {
                                      id: self.record.prescribed_by.id
                                  }),
                                  self.record.prescribed_by.label
                              )
                            : null;
                    }
                });
        },
        getNextDue(recordData) {
            if (recordData.reminder_date && recordData.reminder_date != "") {
                if (typeof recordData.reminder_date == "string")
                    return recordData.reminder_date;
                return this._carbonDateTimeDisplay(recordData.reminder_date);
            } else if (recordData.item_expire && recordData.item_expire != "") {
                return this._carbonDateTimeDisplay(recordData.item_expire);
            }

            return "";
        },
        async save() {
            let self = this;
            let valid = await self.$validator.validateAll();

            if (!valid) {
                self.cancelSave();
                return;
            }

            let bundleIds = [];
            if (Array.isArray(self.item)) {
                forEach(self.item, function (data) {
                    bundleIds.push(data.id);
                });
                bundleIds.join(",");
            } else {
                bundleIds = self.item.id;
            }

            const data = {
                soap_id: self.soap == "-1" ? null : self.soap,
                lab_id: self.record.id,
                patient_id: self.record.patient_id,
                provider_id: self.provider.id,
                item_id: bundleIds,
                supplier_id: self.record.supplier_id,
                order_date: this.orderDate.toSeconds(),
                received_date: self.received
                    ? self._fromDateStrToDateTime(self.received, true)
                    : null,
                due_date: self.nextDue
                    ? self._fromDateStrToDateTime(self.nextDue, true)
                    : null,
                invoice_id: self.invoice,
                instruction: self.data.instruction,
                notes: self.notes,
                source: self.source,
                send_to: self.sendTo,
                sample_id: "",
                is_send_to_lab: self.record.send_to,
                is_print_on_invoice: self.printOnInvoice,
                lab_result_id: "",
                diagnosis_ids: map(this.diagnosis, diagnose => diagnose.value),
                result_id: ""
            };
            let res = await PatientLabService.updateLabDetails(data);

            if (res.code == 200) {
                this._message(res.resources.message);

                if (res.resources.accession_id && res.resources.antech_token) {
                    this.$root.$emit("call-antech-iframe", {
                        antech_token: res.resources.antech_token,
                        accession_id: res.resources.accession_id
                    });
                } else if (
                    (res.resources.lab_ids &&
                        res.resources.lab_ids.length > 0) ||
                    res.resources.lab_id
                ) {
                    let printLabParams = {
                        idexx_lab_id: res.resources.lab_id,
                        idexx_url: [res.resources.idexx_url],
                        lab_ids: [res.resources.lab_id],
                        source: res.resources.lab_extension || self.source,
                        module: "appointment",
                        send_to_lab: res.resources.send_to_lab,
                        isLabProfile: true
                    };

                    self._print_lab_order(printLabParams).then(function (
                        labResponse
                    ) {
                        if (labResponse) {
                            if (labResponse.idexx_iframe) {
                                //load idexx iframe
                                labResponse.module_url =
                                    printLabParams.module_url;
                                labResponse.module = printLabParams.module;

                                self.$root.$emit(
                                    "call_idexx_iframe",
                                    labResponse
                                );
                            } else {
                                //load requisition form modal
                                labResponse.module_url =
                                    printLabParams.module_url;
                                labResponse.module = printLabParams.module;

                                self.$root.$emit(
                                    "call-multirequsition-modal",
                                    labResponse
                                );
                            }
                        }
                    });
                }

                this.$emit("edit-saved", {
                    success: true,
                    lab_id: res.resources.lab_id
                });
            } else {
                this._message(res.message, "danger");
                this.$emit("edit-saved", {
                    success: false
                });
            }
        },
        cancelSave() {
            this.$emit("edit-saved", {
                success: false
            });
        },
        showDate(date) {
            if (!date) return null;
            return this._carbonDateTimeDisplay(date);
        }
    }
};
</script>
